require("./brokerCustomWalletConfigurationView.scss");
//@vendors
const React = require("react");
//commons
const { OKCover } = require('commonsComponents/OKCover');
// @components
const { BrokerCustomWalletConfiguration } = require("../components/brokerCustomWalletConfiguration/brokerCustomWalletConfigurationContainer");
const { BrokerCustomWalletSideBar } = require("../components/brokerCustomWalletSideBar/brokerCustomWalletSideBarContainer");
const { BrokerCustomWalletConfigurationHeader } = require("../components/brokerCustomWalletConfiguration/brokerCustomWalletConfigurationHeaderContainer");

const BrokerCustomWalletConfigurationView = () => {
    return (
        <article className="custom-wallet-landing">
            <OKCover size="medium" section="customwallet">
                <BrokerCustomWalletConfigurationHeader />
            </OKCover>
            <section className="custom-wallet-landing__body">
                <div className="col-xs-8">
                    <BrokerCustomWalletConfiguration />
                </div>
                <div className="col-xs-4">
                    <BrokerCustomWalletSideBar />
                </div>
            </section>
        </article>
    );
};

module.exports = BrokerCustomWalletConfigurationView;
